module.exports = __webpack_public_path__ + "static/media/accepted_active.8c9a10e0.svg";